import React, { ReactElement } from 'react';
import useStylesHiddenBlock from './hidden-block.styles';

const HiddenBlock: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isActive,
    children,
  } = props;

  const { classes } = useStylesHiddenBlock();

  const activeClassName: string | undefined = isActive ? classes.hiddenBlockActive : undefined;

  return (
    <div className={activeClassName}>
      {
        !isActive && (
          children
        )
      }
    </div>
  );
});

export default HiddenBlock;
